export enum PaymentTabEnum {
    Payment = "Manual payment",
    DirectDebitMandate = "Direct debit mandate"
}